import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import styles from './styles.module.scss';

const DefaultControls = ({
	clearHandler,
	applyHandler,
	bottomAligned = false,
	isLoading = false
}) => (
	<div
		className={cx(styles.Controls, {
			[styles.Controls_bottomAligned]: bottomAligned
		})}
	>
		<button
			type="button"
			onClick={clearHandler}
			className={styles.Controls__ClearControl}
		>
			очистить
		</button>
		<button
			type="button"
			onClick={applyHandler}
			className={styles.Controls__ApplyControl}
			disabled={isLoading}
		>
			применить
		</button>
	</div>
);

DefaultControls.propTypes = {
	clearHandler: PropTypes.func.isRequired,
	applyHandler: PropTypes.func.isRequired,
	bottomAligned: PropTypes.bool,
	isLoading: PropTypes.bool
};

export default DefaultControls;
